// Permissions de suppression — CONFORT D'AFFICHAGE UNIQUEMENT.
//
// ⚠️ L'AUTORITÉ EST LE BACKEND. Chaque route de suppression applique sa propre garde
// (403 via utils/authz.py::can_delete) ; ce helper ne fait que masquer des boutons qui
// échoueraient de toute façon. Ne JAMAIS s'en servir pour conclure qu'une action est
// permise — seule la réponse du serveur fait foi.
//
// Miroir EXACT de backend/utils/authz.py::can_delete :
//   acting None                -> False
//   SUPER_ADMIN / ADMIN        -> True (le scoping company/stock est assuré en amont)
//   USER                       -> valeur du flag correspondant
//   type de ressource inconnu  -> False (fail-safe)
//
// Les 3 flags sont exposés par User.to_dict() : ils sont donc déjà dans l'objet user
// du front (localStorage['user'], state App), sans appel supplémentaire.

export const DELETABLE = {
  PRODUCTS: 'products',
  ORDERS: 'orders',
  SUPPLIERS: 'suppliers',
};

const FLAG_BY_RESOURCE = {
  [DELETABLE.PRODUCTS]: 'can_delete_products',
  [DELETABLE.ORDERS]: 'can_delete_orders',
  [DELETABLE.SUPPLIERS]: 'can_delete_suppliers',
};

// Rôles qui passent outre les flags. Source de vérité unique côté front : tout écran
// qui raisonne sur « ce rôle est-il privilégié ? » doit importer cette constante plutôt
// que de recomparer des chaînes (sinon on oublie SUPER_ADMIN quelque part).
export const PRIVILEGED_ROLES = ['SUPER_ADMIN', 'ADMIN'];

export const isPrivilegedRole = (role) => PRIVILEGED_ROLES.includes(role);

export const canDelete = (user, resource) => {
  if (!user) return false;
  if (isPrivilegedRole(user.role)) return true;
  const flag = FLAG_BY_RESOURCE[resource];
  if (!flag) return false;
  return Boolean(user[flag]);
};
